import { render, staticRenderFns } from "./IconBlock.vue?vue&type=template&id=425c3c8c&scoped=true&lang=pug"
import script from "./IconBlock.vue?vue&type=script&lang=ts"
export * from "./IconBlock.vue?vue&type=script&lang=ts"
import style0 from "./IconBlock.vue?vue&type=style&index=0&id=425c3c8c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425c3c8c",
  null
  
)

export default component.exports